module.exports = __webpack_public_path__ + "static/media/hti_logo.c5fe3d78.svg";